import { render } from "./AllStories.vue?vue&type=template&id=cf5caf2c"
import script from "./AllStories.vue?vue&type=script&lang=js"
export * from "./AllStories.vue?vue&type=script&lang=js"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__